//
import React from 'react'
import { useEffect, useState } from 'react'

//  ** ant design

// ** MUI Imports
import BlogReviewDataList from 'src/@core/components/blog-review/BlogReviewDataList'

//  ** Modal
import ModalBlogWriting from 'src/@core/layouts/components/modal/modal_blog_writing'

// ** Utils
import isEmpty from 'lodash/isEmpty'

//  Services
import { useFeedbackData } from 'src/@core/services/firestore/hooks/useFeedbackData'
import { useAuth } from 'src/@core/context/AuthUserContext'

//  Constants
import { REVIEW_SORT_BY_KEY, SORT_BY_KEY, PAGINATION, FEEDBACK_LIST_TYPE } from 'src/constants/Constants'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import { toggleLayoutLoginModal } from 'src/@core/redux/actions'

// ** SSR
import getServerSideProps from 'src/@core/services/ssr/serverProps'

export { getServerSideProps }

const FeedbackPage = props => {
  // State
  const feedbackHookData = useFeedbackData()
  const { dbUser } = useAuth()
  const [visibleBlogDetail, setVisibleBlogDetail] = useState(false)
  const [dataBlogDetail, setDataBlogDetail] = useState(null)

  // Paging
  const [loadingData, setLoadingData] = useState(true)
  const [previousPage, setPreviousPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION.REVIEW)

  useEffect(() => {
    feedbackHookData.actions.subscribeFeedbackCounter()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getCurrentData(previousPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  //
  async function getCurrentData(previous) {
    //
    const sortBy = REVIEW_SORT_BY_KEY.ALL
    const sortType = SORT_BY_KEY.DESC

    //
    await feedbackHookData.actions.getCurrentData(
      FEEDBACK_LIST_TYPE.RATING,
      sortBy,
      '',
      sortType,
      previous,
      currentPage,
      rowsPerPage,
      // eslint-disable-next-line no-unused-vars
      (reviewDataData, error) => {
        if (previous === 1 && currentPage === 1) {
          setLoadingData(false)
        }
      }
    )
  }

  const handleChangePage = newPage => {
    if (currentPage === newPage - 1 || currentPage === newPage + 1) {
      setPreviousPage(currentPage)
      setCurrentPage(newPage)
    }
  }

  const handleChangeRowsPerPage = number => {
    setRowsPerPage(number)
    setCurrentPage(1)
  }

  // eslint-disable-next-line no-unused-vars
  const handleClickAction = async (blogInfo, type) => {}

  const handleClickAddNew = () => {
    if (isEmpty(dbUser)) {
      props.toggleLayoutLoginModal(true)
    } else {
      setDataBlogDetail(dbUser)
      setVisibleBlogDetail(true)
    }
  }

  function handleCancel() {
    setVisibleBlogDetail(false)
  }

  // eslint-disable-next-line no-unused-vars
  const handleClickItem = blogInfo => {
    // props.settingDataOrderModal({ ...blogInfo, editing: false })
    // props.toggleLayoutOrderModal(true)
  }

  return (
    <>
      <BlogReviewDataList
        title={'Đánh giá của người học'}
        subTitle={'Những đánh giá hữu ích cho cộng đồng'}
        dbUser={dbUser}
        isFeedback={true}
        needBadge={false}
        needAction={false}
        needAdd={true}
        loading={loadingData}
        previousPage={previousPage}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        dataList={feedbackHookData.feedbackDataList}
        counterData={feedbackHookData.feedbackCounterData}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onClickAction={handleClickAction}
        onClickAddNew={handleClickAddNew}
        onClickItem={handleClickItem}
      />
      <ModalBlogWriting visible={visibleBlogDetail} userInfo={dataBlogDetail} zIndex={2000} onCancel={handleCancel} />
    </>
  )
}

export function mapDispatchToProps(dispatch) {
  return {
    toggleLayoutLoginModal: value => dispatch(toggleLayoutLoginModal(value))
  }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(React.memo, withConnect)(FeedbackPage)
